/**
 * Error codes as taken from https://stripe.com/docs/error-codes
 * We aren't mapping _every_ error code to text, just the ones that are actionable.
 */

export const STRIPE_ERROR_CODES = {
  card_declined: 'Your payment failed because your card was declined. Please contact your card issuer.',
  balance_insufficient:
    'Your payment failed because your card has insufficient funds. Please add a valid payment method to keep using your account.',
  incorrect_number:
    'Your payment failed because your card number is incorrect. Please add a valid payment method to keep using your account.',
  expired_card:
    'Your payment failed because your card has expired. Please add a valid payment method to keep using your account.',
  authentication_required:
    'Your payment method requires 3DSecure verification. Please check for a notification from your card issuer.',
};

export default function stripeFormatter(
  errorCode: keyof typeof STRIPE_ERROR_CODES | undefined = undefined,
  fallbackText?: string,
) {
  if (!errorCode || !(errorCode in STRIPE_ERROR_CODES)) {
    return fallbackText ?? 'Oh no! Your payment failed. Please add a valid payment method to keep using your account.';
  }

  return STRIPE_ERROR_CODES[errorCode];
}
